import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';

const TONES = {
  success: {
    box: 'bg-green-50 border-cs-green-500',
    icon: CheckCircleIcon,
    iconClass: 'text-cs-green-500'
  },
  warning: {
    box: 'bg-cs-yellow-100 border-cs-yellow-500',
    icon: ExclamationTriangleIcon,
    iconClass: 'text-cs-yellow-600'
  },
  error: {
    box: 'bg-red-50 border-red-500',
    icon: XCircleIcon,
    iconClass: 'text-red-500'
  }
};

/**
 * Inline async-result banner, same look as the share-event dialogs.
 * Errors use role="alert"; everything else role="status" so screen readers
 * announce results without stealing focus.
 */
StatusMessage.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONES)).isRequired,
  title: PropTypes.node.isRequired,
  detail: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node
};

export default function StatusMessage(props) {
  const { tone, title, detail, className, children } = props;
  const { box, icon: Icon, iconClass } = TONES[tone];

  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={classNames('border rounded-cs-10 p-4 flex items-start gap-2', box, className)}
    >
      <Icon className={classNames('h-6 w-6 flex-shrink-0', iconClass)} aria-hidden="true" />
      <div className="flex flex-col gap-1 min-w-0">
        <p className="text-base font-semibold text-cs-gray-900">{title}</p>
        {detail && (
          <p className="text-sm text-cs-gray-900 break-words">{detail}</p>
        )}
        {children}
      </div>
    </div>
  );
}
